import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'navigation-shortcuts.add-link-modal.heading',
		defaultMessage: 'Add shortcut',
		description: '',
	},
	submitCaption: {
		id: 'navigation-shortcuts.add-link-modal.submit-caption',
		defaultMessage: 'Add',
		description: '',
	},
	cancelCaption: {
		id: 'navigation-shortcuts.add-link-modal.cancel-caption',
		defaultMessage: 'Cancel',
		description: '',
	},
	requiredField: {
		id: 'navigation-shortcuts.required-field',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'The description text',
	},
});
